import { render, staticRenderFns } from "./BaseParam.vue?vue&type=template&id=75866981&scoped=true"
import script from "./BaseParam.vue?vue&type=script&lang=js"
export * from "./BaseParam.vue?vue&type=script&lang=js"
import style0 from "./BaseParam.vue?vue&type=style&index=0&id=75866981&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75866981",
  null
  
)

export default component.exports